<template>
  <login-card-shell
    title="ผู้ดูแลระบบ"
    subtitle="หน่วยงาน"
    username-hint="Username: รหัสหน่วยงาน"
    password-hint="Password: ตามที่กำหนด"
    notice-text="ระบบจัดการหน่วยงาน"
    thaid-notice-text="เฉพาะผู้ดูแลระบบส่วนกลาง ต้องยืนยันตัวตนเพิ่มเติมผ่าน ThaiID หลังกรอกรหัสผ่าน (สถานศึกษา/สถาบัน/สอจ. ยังไม่ต้อง)"
    theme-color-start="#e53e3e"
    theme-color-end="#9b2c2c"
    :dialog-value="dialogLogin"
    @update:dialogValue="dialogLogin = $event"
    :snackbar-value="dialog"
    @update:snackbarValue="dialog = $event"
    :snackbar-msg="dialog_msg"
    :loading="loading"
    :lockout-message="lockoutMessage"
    @submit="userLogin"
  >
    <template v-slot:extra-action>
      <reset-password-dialog person-type="college" />
    </template>

    <v-form ref="form" lazy-validation>
      <v-text-field
        color="error"
        prepend-icon="mdi-account"
        name="login"
        label="ชื่อผู้ใช้งาน (รหัสหน่วยงาน)"
        type="text"
        v-model="user_name"
        :rules="[v => !!v || 'กรุณากรอกชื่อผู้ใช้งาน']"
        rounded
        outlined
        class="enhanced-input mb-4"
      ></v-text-field>

      <v-text-field
        color="error"
        name="password"
        label="รหัสผ่าน"
        prepend-icon="mdi-lock-outline"
        id="password"
        v-model="user_password"
        rounded
        :rules="[v => !!v || 'กรุณากรอกรหัสผ่าน']"
        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show1 ? 'text' : 'password'"
        @click:append="show1 = !show1"
        outlined
        class="enhanced-input"
        hint="ตามที่ส่วนกลางกำหนด"
        persistent-hint
      ></v-text-field>
    </v-form>
  </login-card-shell>
</template>

<script>
import LoginCardShell from "./LoginCardShell.vue";
import resetPasswordDialog from "./ResetPasswordDialog.vue";

export default {
  components: { LoginCardShell, resetPasswordDialog },
  data() {
    return {
      ApiKey: "HRvec2021",
      show1: false,
      dialogLogin: false,
      data_syslog: {},
      user_name: "",
      user_password: "",
      dialog: false,
      dialog_msg: "",
      loading: false,
      lockoutMessage: ""
    };
  },
  methods: {
    async userLogin() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.lockoutMessage = "";
      try {
        let result = await this.$http.post("login.php?crud=admin", {
          user_name: this.user_name,
          user_password: this.user_password
        });

        if (result.data.user_status === "Locked") {
          const minutes = Math.ceil((result.data.retry_after || 0) / 60);
          this.lockoutMessage = `ล็อกอินผิดเกินกำหนด กรุณารออีกประมาณ ${minutes} นาที`;
          return;
        }

        if (result.data.user_status === "NeedThaidVerify") {
          // รหัสผ่านถูกต้องแล้ว แต่ยังไม่ออก session จนกว่าจะยืนยันตัวตนผ่าน ThaiID สำเร็จ —
          // ต้อง redirect ทั้งหน้า (ไม่ใช่ XHR) เพราะเป็น cross-origin ไปหน้า DOPA
          this.dialog_msg = "กำลังนำท่านไปยืนยันตัวตนทางดิจิทัลผ่าน ThaiID (ออกให้โดยกรมการปกครอง กระทรวงมหาดไทย) กรุณาสแกน QR Code หรือยืนยันผ่านแอป ThaID ในขั้นตอนถัดไป...";
          this.dialog = true;
          window.location.href = result.data.authorize_url;
          return;
        }

        if (result.data.user_status) {
          let user = result.data;
          user.system_lock = false;
          localStorage.setItem("user", JSON.stringify(user));

          const redirectMap = {
            A: { path: "/admin", msg: "เข้าสู่ระบบสำเร็จ - ผู้ดูแลระบบ" },
            B: { path: "/college", msg: "เข้าสู่ระบบสำเร็จ - วิทยาลัย" },
            C: { path: "/iven", msg: "เข้าสู่ระบบสำเร็จ - Inventory" },
            D: { path: "/personnel", msg: "เข้าสู่ระบบสำเร็จ - บุคลากร" },
            G: { path: "/vecprovince", msg: "เข้าสู่ระบบสำเร็จ - จังหวัด" },
            S: { path: "/supervisions", msg: "เข้าสู่ระบบสำเร็จ - การนิเทศ" }
          };

          const target = redirectMap[user.user_status];
          if (target) {
            if (user.user_status === "A") {
              this.data_syslog = {
                ApiKey: this.ApiKey,
                user_account: this.user_name,
                event_log: "login-admin",
                page_log: "loginAdmin",
                table_log: "",
                date_times: this.date_today_log
              };
              await this.$http.post("data_syslog.insert.php", this.data_syslog);
            }

            this.dialogLogin = false;
            this.dialog = true;
            this.dialog_msg = target.msg;
            setTimeout(() => {
              this.$router.push(target.path);
            }, 1500);
          } else {
            localStorage.clear();
            this.dialog = true;
            this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
          }
        } else {
          this.dialog = true;
          this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
        }
      } catch (error) {
        this.dialog = true;
        this.dialog_msg = "เกิดข้อผิดพลาดในการเข้าสู่ระบบ";
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return dd + "/" + mm + "/" + yyyy + "/" + time;
    }
  }
};
</script>

<style scoped>
.enhanced-input .v-input__control {
  transition: all 0.3s ease;
}

.enhanced-input:hover .v-input__control {
  transform: translateY(-1px);
}
</style>
